<template>
  <section class="junior-classes" aria-labelledby="junior-classes-title">
    <div class="section-heading">
      <p>2026 · NEW SYSTEM</p>
      <h2 id="junior-classes-title">初中四大班型</h2>
      <span>从新初一开始，根据学习基础与培养目标精准匹配</span>
    </div>

    <article
      v-for="(item, index) in classes"
      :key="item.name"
      class="class-card"
      :class="{ reverse: index % 2 === 1 }"
    >
      <div class="card-copy">
        <div class="title-row">
          <div>
            <p class="english-title">{{ item.english }}</p>
            <h3>{{ item.name }}</h3>
          </div>
          <span class="former-name">原名：{{ item.former }}</span>
        </div>

        <div class="facts">
          <p><strong>适合学生</strong>{{ item.students }}</p>
          <p><strong>学习进度</strong>{{ item.progress }}</p>
          <p><strong>培养目标</strong>{{ item.goal }}</p>
          <p class="detail">{{ item.detail }}</p>
        </div>
      </div>

      <div v-if="item.image" class="card-visual">
        <img :src="item.image" :alt="item.name + '课程配图'" />
        <span class="class-index">0{{ index + 1 }}</span>
      </div>
      <div v-else class="card-visual building-visual" aria-hidden="true">
        <span class="class-index">0{{ index + 1 }}</span>
        <div class="growth-line growth-line-one" />
        <div class="growth-line growth-line-two" />
        <img src="/static/img/course-image-535.png" alt="" />
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: "CourseJuniorClassesSubsection",
  data() {
    return {
      classes: [
        {
          name: "初中国培班",
          english: "Junior High School National Training Class",
          former: "联赛班、兴趣班",
          students: "具备极强数学天赋的同学。",
          progress: "3 年贯通初高中数学体系：1.5 年完成初中课内与初中联赛，1.5 年完成高中课内与高联一试。",
          goal: "中高考满分，冲刺高联保送与强基计划。",
          detail: "国培班在石家庄教培界颇具影响力，已培养出大量顶尖学子。",
          image: "/static/img/course-image-1.png",
        },
        {
          name: "初中创新班",
          english: "Junior High School Innovation Class",
          former: "尖端班",
          students: "对数学有兴趣，校内数学满分或接近满分的同学。",
          progress: "2 年完成初中体系，0.25 年专项突破中考压轴题，1.25 年学习高中课内。",
          goal: "中考满分与二中自招，并具备解决初级联赛题目的能力。",
          detail: "课程含 20%—30% 深度拓展内容，强化压轴题方法、自招内容与竞赛基础。",
          image: "/static/img/course-image.png",
        },
        {
          name: "初中通识班",
          english: "Junior High School General Studies Class",
          former: "尖子1班",
          students: "学习习惯良好，校内成绩优秀（115+，满分 120）的同学。",
          progress: "2.5 年完成初中体系，0.5 年完成两轮中考复习；同一模块学习两遍：第 1 遍着重基础理解，保障全面无死角；第 2 遍着重题型归类与压轴题拔高。",
          goal: "保障课内基础，着重提升压轴题能力，冲刺课内满分与中考满分。",
          detail: "通识班是全新升级的课程体系，未来将打造成人数最多的班型，也是面向中考最务实的班型；2020 年石家庄中考总分状元也出自本班型。",
          image: "/static/img/course-image-533.png",
        },
        {
          name: "初中勤思班",
          english: "Junior High School Qinsi Class",
          former: "尖子班、培优班",
          students: "校内成绩 100—115（满分 120），希望提升解题能力的同学。",
          progress: "2.5 年完成初中体系，0.5 年中考复习；暑寒先修，春秋拓展，同一知识学习两遍。",
          goal: "稳定课内基础，提升中档题与压轴题能力，冲刺校内高分与中考 110+。",
          detail: "校内考什么，勤思班就讲什么；这是原 XES 受众人数最多、当前云帆培优人数最多且卧虎藏龙的班型，已培养出大量优秀学子。",
          image: "/static/img/course-qinsi-class.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.junior-classes {
  left: 172px;
  position: absolute;
  top: 2098px;
  width: 1568px;
}

.section-heading {
  align-items: flex-end;
  display: flex;
  height: 104px;
  margin-bottom: 48px;
  position: relative;
}

.section-heading::before {
  background: linear-gradient(180deg, #069ee0 0%, #025dd4 100%);
  content: "";
  height: 72px;
  left: 0;
  position: absolute;
  top: 18px;
  width: 6px;
}

.section-heading p {
  color: #1674cc;
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
  left: 30px;
  letter-spacing: 2.8px;
  margin: 0;
  position: absolute;
  top: 11px;
}

.section-heading h2 {
  color: #00183c;
  font-family: "PingFang SC-Semibold", "PingFang SC", Helvetica, sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  margin: 0 0 0 30px;
}

.section-heading span {
  color: #6c7a90;
  font-family: "PingFang SC-Regular", "PingFang SC", Helvetica, sans-serif;
  font-size: 18px;
  margin: 0 0 10px 30px;
}

.class-card {
  background: #f9fafb;
  box-shadow: 0 18px 54px rgba(0, 24, 60, 0.08);
  display: flex;
  height: 450px;
  margin-bottom: 64px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.class-card:last-child {
  margin-bottom: 0;
}

.class-card.reverse {
  flex-direction: row-reverse;
}

.card-copy {
  background: rgba(249, 250, 251, 0.97);
  flex: 1;
  min-width: 0;
  padding: 42px 58px 36px;
}

.title-row {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  min-height: 78px;
  position: relative;
}

.title-row h3 {
  color: #1c4b8a;
  font-family: "PingFang SC-Semibold", "PingFang SC", Helvetica, sans-serif;
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  margin: 0;
  position: relative;
  z-index: 1;
}

.english-title {
  color: rgba(0, 0, 0, 0.06);
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 34px;
  font-weight: 600;
  left: 0;
  line-height: 42px;
  margin: 0;
  position: absolute;
  top: 28px;
  white-space: nowrap;
}

.former-name {
  background: #eaf3ff;
  border: 1px solid #d6e8ff;
  border-radius: 18px;
  color: #2c67a8;
  font-family: "PingFang SC-Medium", "PingFang SC", Helvetica, sans-serif;
  font-size: 15px;
  line-height: 28px;
  margin-left: 20px;
  padding: 0 16px;
  white-space: nowrap;
}

.facts {
  color: #00183c;
  font-family: "PingFang SC-Regular", "PingFang SC", Helvetica, sans-serif;
  margin-top: 14px;
}

.facts p {
  font-size: 17px;
  line-height: 30px;
  margin: 0 0 7px;
}

.facts strong {
  color: #1c4b8a;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  margin-right: 16px;
  min-width: 72px;
}

.facts .detail {
  border-top: 1px solid #dfe7f1;
  color: #52627a;
  font-size: 15px;
  line-height: 25px;
  margin-top: 12px;
  padding-top: 10px;
}

.card-visual {
  background: #dcebf8;
  flex: 0 0 560px;
  height: 450px;
  overflow: hidden;
  position: relative;
}

.card-visual::after {
  background: linear-gradient(180deg, rgba(0, 24, 60, 0) 58%, rgba(0, 24, 60, 0.38) 100%);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.card-visual > img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.class-index {
  bottom: 24px;
  color: rgba(255, 255, 255, 0.95);
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 58px;
  font-weight: 600;
  left: 28px;
  line-height: 1;
  position: absolute;
  z-index: 2;
}

.reverse .class-index {
  left: auto;
  right: 28px;
}

.building-visual {
  background: linear-gradient(145deg, #069ee0 0%, #025dd4 100%);
}

.building-visual > img {
  bottom: -230px;
  height: auto;
  opacity: 0.72;
  position: absolute;
  right: -8px;
  width: 520px;
  z-index: 1;
}

.growth-line {
  border-left: 7px solid rgba(255, 255, 255, 0.55);
  border-top: 7px solid rgba(255, 255, 255, 0.55);
  height: 86px;
  position: absolute;
  transform: rotate(45deg);
  width: 86px;
}

.growth-line-one {
  left: 118px;
  top: 83px;
}

.growth-line-two {
  left: 267px;
  top: 35px;
  transform: rotate(45deg) scale(0.72);
}
</style>
